import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, ContentChild, HostBinding, Input, TemplateRef,} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Component used to display data
 * @name Key-value
 * @tags Data, Display, Summary, Key, Value
 */
@Component({
    selector:    'v-kv',
    styleUrls:   ['./v-kv.component.sass'],
    templateUrl: './v-kv.component.haml',
    standalone:  true,
    imports:     [CommonModule, TranslateModule,],
})
export class VKVComponent{
    @ContentChild('content', { static: false}) public contentTemplateRef: TemplateRef<unknown>;
    @ContentChild('header', { static: false}) public headerTemplateRef: TemplateRef<unknown>;
    /**
     * @default false
     */
    @Input({transform: booleanAttribute}) @HostBinding('class.container') public container: boolean = false;
    /**
     * If set to true, it will hide the component when "value" is empty.
     * @default false
     */
    @Input({transform: booleanAttribute}) public hideOnEmpty: boolean = false;
    /**
     * Used for adding the styling class "less-intensity".
     * @default true
     */
    @Input({transform: booleanAttribute}) public highlightEmpty: boolean = true;
    /**
     * It's the bolded text/header shown first.
     */
    @Input() public key: string;
    /**
     * A text shown when the value is empty. It translates to "Not specified".
     * @default 'Keine Angabe'
     */
    @Input() public nullValue: string = 'Keine Angabe';
    /**
     * Value can be anything.
     * @example Simple KV
     * ```
     * %v-kv{key: "My Key", value: "My Value"}
     * ```
     * @example Content Projection
     * ```
     * %v-kv{key: "My Key"}
     *      My Value
     * ```
     * @example Templating
     * ``` 
     * %v-kv{key: "My Key", value: "My Value"}
     *      %ng-template{#header, let-data}
     *          {{data}}
     *      %ng-template{#content, let-data}
     *          {{data}}
     * ```  
     */
    @Input() public value: unknown;

    public hasContent(ref: HTMLElement){
        return ref.children.length > 0 || ![null, undefined, ''].includes(ref.textContent?.trim());
    }
}
